module.exports = __webpack_public_path__ + "static/media/faq_opened.4ab09c81.svg";